import {api} from '../resources'

export default {
    namespaced: true,
    state: {
        invitations: [],
        invitations_sent: []
    },
    getters: {},
    actions: {
        setUserInvites({commit}, invites) {
            invites.forEach((invite) => {
                commit('pushReceivedInvite', invite)
            })
        },
        getSentInvitations({commit, rootState}) {
            const space_id = rootState.space.current_space.data.id;
            api.invitations_sent.get({space_id}).then(res => {
                if (res.body.success) {
                    commit('setSentInvitations', res.body.data.rows);
                }
            });
        },
        async connectInviteWithToken({commit}, token) {
            return api.connect_invite_token.get({token});
        },

        acceptInvite({commit}, id) {
            return api.accept_invite.save({id});
        },
        declineInvite({commit}, id) {
            return api.decline_invite.save({id});
        }
    },
    mutations: {
        pushReceivedInvite(state, data) {
            state.invitations.push(data);
        },
        pushCookieReceivedInvite(state, data) {
            let id = data.id;
            if (!state.invitations.some(item => item.id === id)) {
                state.invitations.push(data);
            }
        },
        removeInviteById(state, id) {
            state.invitations = state.invitations.filter(invite => invite.id !== id)
        },
        clearInvites(state) {
            state.invitations = [];
        },
        setSentInvitations(state, data) {
            state.invitations_sent = data;
        }
    }
}
